module.exports = __webpack_public_path__ + "img/wymf.58234060.gif";